function logIt(msg: string, meta: any, level: string) {
    meta = {
        path: window.location.pathname,
        ...meta
    }
    window['DD_LOGS'].logger.log(msg, meta, "info")
}

function toastE(that: any, msg: string, meta: any) {
    console.error(meta);
    setTimeout(() => {
        that.$toast.open({
            message: msg,
            type: 'error',
            duration: 3000,
            position: 'top-right'
        });
    }, 1500);
}

export default {
    methods: {
        logInfo(msg: string, meta: any) {
            logIt(msg, meta, "info")
        },
        logError(msg: string, meta: any) {
            logIt(msg, meta, "error")
        },
        logWarn(msg: string, meta: any) {
            logIt(msg, meta, "warn")
        },
        logDebug(msg: string, meta: any) {
            logIt(msg, meta, "debug")
        },
        toastAndError(that: any, msg: string, meta: any) {
            toastE(that, msg, meta);
            logIt(msg, meta, "error");
        }
    }
}